import { useState } from 'react'
import type { AdminLeaveType } from '../../pages/admin/catalogStore'

const FIELD = 'min-h-11 w-full rounded-control border border-line-strong px-2.5 text-small'
const LABEL = 'mb-1 block text-caption font-bold text-ink-muted'

/**
 * A leave type's name: entered when one is created and changed afterward. The
 * requests that name a type read its current name, so renaming one changes how
 * they read; the form says how many that is.
 */
export default function LeaveTypeForm({
  leaveType,
  saving,
  error,
  onSave,
  onCancel,
}: {
  leaveType?: AdminLeaveType
  saving: boolean
  error: string | null
  onSave: (name: string) => void
  onCancel: () => void
}) {
  const [name, setName] = useState(leaveType?.name ?? '')
  const canSave = name.trim() !== '' && name.trim() !== leaveType?.name

  return (
    <form
      className="flex flex-col gap-3 rounded-surface border border-line bg-canvas p-3"
      aria-label={leaveType ? `Edit ${leaveType.name}` : 'Create leave type'}
      onSubmit={(event) => {
        event.preventDefault()
        if (canSave && !saving) onSave(name.trim())
      }}
    >
      <div className="max-w-md">
        <label htmlFor="leave-type-name" className={LABEL}>
          Name
        </label>
        <input id="leave-type-name" type="text" maxLength={100} value={name} onChange={(event) => setName(event.target.value)} className={FIELD} />
      </div>
      {leaveType && leaveType.requests > 0 && canSave && (
        <p role="status" className="text-small text-warning">
          {leaveType.requests} leave {leaveType.requests === 1 ? 'request names' : 'requests name'} this type and will read as the new name.
        </p>
      )}
      {error && (
        <p role="alert" className="text-caption font-semibold text-error">
          {error}
        </p>
      )}
      <div className="flex gap-2">
        <button
          type="submit"
          disabled={!canSave || saving}
          className="flex min-h-11 items-center justify-center rounded-control bg-primary px-4 text-small font-bold text-primary-ink hover:bg-primary-hover disabled:opacity-40"
        >
          {saving ? 'Saving…' : leaveType ? 'Save changes' : 'Create leave type'}
        </button>
        <button
          type="button"
          onClick={onCancel}
          className="flex min-h-11 items-center justify-center rounded-control px-4 text-small font-bold text-ink-muted hover:bg-surface-2"
        >
          Cancel
        </button>
      </div>
    </form>
  )
}
